/** @file nodeSide: the left/right side a node name declares (`armL`, `hand_r`, `LeftFoot`), or null. */

const WORD = '[lLrR]|[Ll]eft|[Rr]ight|LEFT|RIGHT';
const SEPARATED = new RegExp(`[_.-](${WORD})$`);
const CAMEL = /[a-z0-9](L|R|Left|Right)$/;
const PREFIX = new RegExp(`^(?:(${WORD})[_.-]|(Left|Right)[A-Z])`);

/** `'l'` / `'r'` from a separated or camel-case suffix, or a `l_` / `Left` prefix; null for a centre node. */
export function nodeSide(name: string): 'l' | 'r' | null {
  const raw = SEPARATED.exec(name)?.[1] ?? CAMEL.exec(name)?.[1] ?? PREFIX.exec(name)?.[1] ?? PREFIX.exec(name)?.[2];
  if (raw === undefined) return null;
  return raw.charAt(0).toLowerCase() === 'l' ? 'l' : 'r';
}
